<div class="empty-message">
  <mat-icon class="icon" *ngIf="icon">{{ icon }}</mat-icon>
  <span class="text">{{ emptyMessage | translate }}</span>
  <button *ngIf="hasAction" (click)="action.emit($event)"
          mat-button class="custom-secondary-button update-page-button">
    {{ actionMessage | translate }}
  </button>
</div>
